import { useQuery } from "@tanstack/react-query"
import { ApplicationRoleDetail } from "../app/models/ApplicationRole"
import { digitalManagerApi } from "../services/api"

interface ApplicationPermissionFirmwareConstraintApplicationRoleGet {
  applicationRole: ApplicationRoleDetail
}

export function useApplicationPermissionFirmwareConstraintRoles(
  applicationId?: string,
  permissionId?: string,
  firmwareConstraintId?: string
) {
  const {
    data: firmwareConstraintRoles = [],
    isLoading: isLoadingFirmwareConstraintRoles,
    refetch: refetchFirmwareConstraintRoles,
  } = useQuery({
    queryKey: [
      "firmwareConstraintRoles",
      applicationId,
      permissionId,
      firmwareConstraintId,
    ],
    queryFn: () =>
      digitalManagerApi
        .get<ApplicationPermissionFirmwareConstraintApplicationRoleGet[]>(
          `/applications/${applicationId}/permissions/${permissionId}/firmwareConstraints/${firmwareConstraintId}/roles`
        )
        .then((r) => r.data.map((item) => item.applicationRole)),
    enabled: !!applicationId && !!permissionId && !!firmwareConstraintId,
  })

  return {
    firmwareConstraintRoles,
    isLoadingFirmwareConstraintRoles,
    refetchFirmwareConstraintRoles,
  }
}
